import React, { useRef, useState } from 'react'
import correctSample from '../audio/correct.mp3'
import failSample from '../audio/fail.mp3'

export const QuizContext = React.createContext()

const QuizContextProvider = (props) => {

  const [questionInfo, setQuestionInfo] = useState()
  const [questionNumber, setQuestionNumber] = useState(0)
  const [result, setResult] = useState([])
  const correctRef = useRef()
  const wrongRef = useRef()
  const playCorrectSound = () => {
    correctRef.current.play()
  }
  const playWrongSound = () => {
    wrongRef.current.play()
  }

  const updateScoreCounter = (correct) => {
    setResult(prevResult => {
      return prevResult.map((v,i) => (i === questionNumber) ? correct : v)
    })
  }

  return (
    <QuizContext.Provider value={{
      questionInfo, 
      setQuestionInfo, 
      playCorrectSound, 
      playWrongSound,
      questionNumber,
      setQuestionNumber,
      result,
      setResult,
      updateScoreCounter
    }}>
      {props.children}
      <audio ref={correctRef} src={correctSample} preload='auto' />
      <audio ref={wrongRef} src={failSample} preload='auto' />
    </QuizContext.Provider>
  )
}

export default QuizContextProvider